import React, { useEffect } from 'react'
import { getUserInfo } from '../storage'

export const Binds = () => {
  const storage = getUserInfo()
  const user = storage?.login?.user

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://widget-v3.web.app/js/app.js'
    script.async = true
    document.body.appendChild(script)

    const link = document.createElement('link')
    link.href = 'https://widget-v3.web.app/css/app.css'
    link.rel = 'stylesheet'
    document.head.appendChild(link)
  }, [])

  return (
    <div>
      <div>
        <vue-widget
          widget_position="bottom-right"
          widget_title="feedback"
          buttons="#11bb77"
          width="100"
          height="80"
          text_buttons="#ffffff"
          background="#11bb77"
          texts="#fff"
          timeout="0"
          width_metric="px"
          survey_id="64d62c9f9bf5642a45617684"
          close_button="true"
          close_permanently="false"
          response_background="#eeeeee"
          hidde_after_answer="false"
          hidde_when_click_to_close="false"
          response_font_color="#0a0a0a"
          font_family="'Helvetica', 'Arial', sans-serif"
          font_size="medium"
          text_props="{'bold':'false','italic':'false','underline':'false', 'margin': '30px',}"
          border_radius="10"
          from={`{"name": "${user?.fullName}", "email": "${user?.email}", "phone":"${user?.cellphone}"}`}
          is_to_post="true"
          metadata="{}"
        />
      </div>
    </div>
  )
}
